<template>
  <div class="TmMultiImgEdit TmTextEdit myTumengImg">
    <el-tabs :stretch="true" value="style">
      <el-tab-pane
        :label="$t('lcd.Editor.Style')"
        name="style"
        class="style-pane"
      >
        <!-- {{fields}} -->
        <!-- {{state}} -->
        <!-- templateType:{{templateType}} -->
        <attr-row
          :label="$t('lcd.Editor.Layer Name') + ' : ' + conf.name"
        ></attr-row>
        <attr-row :label="$t('lcd.Editor.Position and Size')">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.left"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeX"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">X</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.top"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeY"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">Y</div>
              </template>
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.width"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeW"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">W</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.height"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeH"
            >
              <template slot="prepend"
                ><div style="width: 12px; text-align: center">H</div></template
              >
            </el-input>
          </div>
        </attr-row>
        <attr-row
          :label="$t('lcd.Editor.Rotate')"
          :height="38"
          class="custom-smaller-slider-btn2"
        >
          <el-slider
            v-model="conf.rotate"
            :min="0"
            :max="360"
            style="margin-left: 10px;"
          />
          <el-input-number
            v-model="conf.rotate"
            controls-position="right"
            :min="0"
            :max="360"
            size="mini"
          />
        </attr-row>
        <attr-row :label="$t('lcd.Editor.Image Origin')">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.imgList[0].imgSrc"
              :placeholder="$t('lcd.Editor.Please Input Image Origin')"
              size="mini"
              disabled
              style="width: 49%"
            />
            <el-select
              v-model="conf.datasetField"
              size="mini"
              clearable
              filterable
              :placeholder="$t('lcd.Editor.Please Select Data Field')"
              style="width: 49%"
              v-if="templateType != 1"
            >
              <el-option
                v-for="field in goodsFields"
                :key="field.value"
                :label="field.label"
                :value="field.value"
                :disabled="field.type != 'img'"
              />
            </el-select>
          </div>
        </attr-row>
        <div v-for="it in conf.imgList" :key="it.src">
          <attr-row :label-width="0">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <image-box
                @click.native="handleClickAddImg()"
                :src="it.imgSrc"
                :conf="it"
                width="100%"
                style="cursor: pointer; object-fit: contain"
              />
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('lcd.Editor.Change Image')"
                placement="top"
              >
                <el-button
                  size="mini"
                  icon="el-icon-refresh"
                  circle
                  style="margin-left: 12px;"
                  @click="handleClickAddImg"
                >
                </el-button>
              </el-tooltip>
            </div>
          </attr-row>
        </div>

        <!-- 显示逻辑 -->
        <attr-row
          :label="$t('lcd.Editor.isShow')"
          class="tt"
          style="position: relative"
          v-if="templateType != 1"
        >
          <el-radio-group v-model="conf.hide">
            <el-radio size="mini" :label="true">{{
              $t("lcd.Editor.hide text")
            }}</el-radio>
            <el-radio size="mini" :label="false">{{
              $t("lcd.Editor.show text")
            }}</el-radio>
          </el-radio-group>
          <!-- {{conf.showLogic}} -->
          <el-button
            class="logicBtn"
            type="text"
            size="mini"
            @click.native="showLogicDialog"
            >{{ $t("lcd.Editor.show logic") }}</el-button
          >
        </attr-row>

        <!-- <attr-row
          :label="$t('lcd.Editor.Rotate')"
          :height="38"
          class="custom-smaller-slider-btn2"
        >
          <div style="padding: 0 0 0 8px">
            <el-slider v-model="conf.rotate" :min="0" :max="360" />
            <el-input-number
              v-model="conf.rotate"
              controls-position="right"
              :min="0"
              :max="360"
              size="mini"
            />
          </div>
        </attr-row> -->
      </el-tab-pane>
    </el-tabs>
    <LogicDialog
      :logicDetail="conf.showLogic"
      ref="logicRef"
      @getLogic="getLogic"
    ></LogicDialog>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import AttrRow from "../../tumeng-attr-row/src/index.vue";
import ImageBox from "../../tumeng-Image/Image.vue";
import eventbus from "../../../utils/eventbus";
import LogicDialog from "../../tumeng-display/src/index.vue";

export default {
  name: "TumengMultiImgEdit",
  props: {
    goodsFields: {
      type: Array,
      default: [],
    },
  },
  components: {
    AttrRow,
    ImageBox,
    LogicDialog,
  },
  data() {
    return {
      state: store.state,
      localRadius: null,
      isMore: true,
      canvasWidth: store.state.programInfo.width,
      canvasHeight: store.state.programInfo.height,
      Maximum: parseInt(store.state.programInfo.width) >= parseInt(store.state.programInfo.height)
          ? parseInt(store.state.programInfo.width)
          : parseInt(store.state.programInfo.height)
  
    };
  },
  computed: {
    templateType() {
      return store.state.programInfo.templateGroup
    },
    conf() {
      return store.state.activeComponent;
    },
    // fields() {
    //   let fields = null;
    //   // if (store.state.programInfo.templateGroupId == 0) {
    //   //   fields = JSON.parse(store.state.programInfo.goodsFields);
    //   // }
    //   if (fields) {
    //     return fields;
    //   }
    //   return undefined;
    // },
  },
  methods: {
    handleClickImg(index) {
      if (this.conf.imgList.length > 1) {
        this.conf.imgList.splice(index, 1);
      } else {
        this.$message({
          type: "warning",
          message: "至少需要一张图片",
          duration: 2000,
        });
      }
    },
    handleClickAddImg() {
      eventbus.$emit("img-list-change", 1);
      store.SET_SELECT_IMG_OPERATION("ADD_IMAGE");
      store.updateSelectImgDialogVisible(true);
    },
    // handleLock(){
    //   console.log('handleLock',this.conf.isLock)
    //   this.conf.isLock = !this.conf.isLock
    //   console.log('handleLock2222',this.conf.isLock)
    // }
    changeRangeX(e) {
      console.log("X", e);
      console.log(this.canvasWidth, this.canvasHeight);
      let confX = +e;
      if (this.conf.rotate == 0 || this.conf.rotate == 360) {
        if (confX > this.canvasWidth - this.conf.width) {
          confX = this.canvasWidth - this.conf.width;
        } 
      } else {
        if (confX > this.canvasWidth) {
          confX = this.canvasWidth
        } 
      }
      if (confX < 0 - this.canvasWidth) {
        confX = 0 - this.canvasWidth;
      }
      this.conf.left = parseInt(confX);
    },
    changeRangeY(e) {
      let confY = +e;
      if (this.conf.rotate == 0 || this.conf.rotate == 360) {
        if (confY > this.canvasHeight - this.conf.height) {
          confY = this.canvasHeight - this.conf.height;
        }
      } else {
        if (confY > this.canvasHeight) {
          confY = this.canvasHeight
        } 
      }
      if (confY < 0 - this.canvasHeight) {
        confY = 0 - this.canvasHeight;
      }
      this.conf.top = parseInt(confY);
    },
    changeRangeW(e) {
      let confW = +e;
      // x坐标小于0时，等于0
      const leftValue = this.conf.left > 0 ? this.conf.left : 0
      if (this.conf.rotate == 0 || this.conf.rotate == 360) {
        if (confW > this.canvasWidth - leftValue) {
          confW = this.canvasWidth - leftValue;
        }
      } else {
        if (confW > this.Maximum) {
          confW = this.Maximum;
        }
      }
      if (confW < 0) {
        confW = 0;
      }
      this.conf.width = parseInt(confW);
    },
    changeRangeH(e) {
      let confH = +e;
      // y 坐标小于0时，等于0
      const topValue = this.conf.top > 0 ? this.conf.top : 0
      if (this.conf.rotate == 0 || this.conf.rotate == 360) {
        if (confH > this.canvasHeight - topValue) {
          confH = this.canvasHeight - topValue;
        }
      } else {
        if (confH > this.Maximum) {
          confH = this.Maximum;
        }
      }
      if (confH < 0) {
        confH = 0;
      }
      this.conf.height = parseInt(confH);
    },
    changeTA(ta) {
      this.conf.textAlign = ta;
    },
    changeVA(va) {
      this.conf.verticalAlign = va;
    },

    showLogicDialog() {
      this.$refs.logicRef.open();
      console.log(12333333);
    },
    getLogic(val) {
      console.log(val);
      this.conf.showLogic = val;
    },
  },
  mounted() {
    if (this.conf.imgList.length) {
      this.conf.imgList = this.conf.imgList.map((img) => {
        if (!img.imgFormat) {
          const list = img.imgSrc.split(".");
          img.imgFormat = list[list.length - 1];
        }
        return img;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.TmMultiImgEdit {
  margin: 8px;
  color: white;
  height: calc(100% - 16px);
  overflow: auto;
  > button.el-button.el-button--default.el-button--mini.is-circle {
    padding: 0;
  }
  .prop-pane {
    // 添加视频按钮变宽
    > button.el-button.el-button--default.el-button--small {
      width: 100%;
    }
    // 展示图片列表的div
    .img-item {
      margin: 0 12px 8px 4px;
      padding: 4px;
      border: 1px dashed white;
      width: calc(100% - 26px);
      height: 150px;
      text-align: left;
      position: relative;
      > img {
        float: left;
      }
      > div {
        float: left;
      }
      // 删除图片按钮
      > button.el-button.el-button--default.el-button--mini.is-circle {
        padding: 0;
        position: absolute;
        right: 0;
        top: 59px;
        transform: translate(5px, -50%);
      }
      // 让图片时长输入框和图片之间有个间距
      div.el-input-number {
        margin-top: 8px;
        text-align: left;
      }
      // 图片时长输入框的增加、减小按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }
      > div {
        // 图片时长输入框行高
        > span {
          display: inline-block;
          line-height: 28px;
          height: 28px;
          color: #000;
        }
      }
    }
  }
  .style-pane {
    // 横纵坐标、宽高样式
    @import "../../../assets/style/ltwh";

    .custom-smaller-slider-btn2 {
      // 旋转和透明度的slider的拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }
      // 旋转和透明度的slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 86px);
        margin-right: 16px;
        float: left;
      }
      // 隐藏旋转和透明度数字输入框的增加、减少按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }
      // 让旋转和透明度的数字输入框便的正常
      ::v-deep input.el-input__inner {
        padding: 0;
      }
      // 指定旋转和透明度的输入框宽度宽度
      ::v-deep .el-input-number.el-input-number--mini {
        width: 60px;
        float: left;
        margin-top: 5px;
      }
      .radius-box {
        ::v-deep .el-slider {
          width: 100%;
        }
        ::v-deep .el-slider__input {
          width: 60px;
        }
        ::v-deep .el-slider__runway.show-input {
          margin-right: 76px;
        }
        ::v-deep .el-slider__stop {
          display: none;
        }
        ::v-deep .el-slider__marks-text {
          margin-top: 5px;
        }
      }
    }
  }
}
// .lock{
//   position: absolute;
//   right: 0;
//   top: 8px;
//   font-size: 14px;
//   cursor: pointer;
// }
.logicBtn {
  position: absolute;
  top: 0px;
  right: -15px;
  z-index: 101;
  &.el-button.el-button--mini {
    font-size: 12px;
  }
}
</style>
<style lang="scss">
.myTumengImg {
  button.el-button.el-button--default.el-button--mini.is-circle {
    padding: 0;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
  }
}
</style>